import * as React from "react";
import { API } from "../API";
import AgenciesListActivity from "../components/AgenciesList/AgenciesListActivity";
import { cancelAgencyRequest } from "../components/MyAgencies/utils/cancelAgencyRequest";
import { ScreenSkeleton } from "../components/ScreenSkeleton";
import { isLoading } from "../Loading";
import { AgencyMemberId } from "../messages/ObjectIds";
import { STRINGS } from "../strings";
import { AppState } from "../system/AppState";
import { translate } from "../translate";
import { ActivityStateMixin, ActivityStateMixinState } from "./ActivityStateMixin";

interface AddChatActivityProps {
  api: API;
  appState: AppState;
  onBackClick: () => void;
  onAddChat: (AgencyMemberId: AgencyMemberId) => void;
  onAddChatMedflytAgency: () => void;
}

interface AddChatActivityState {
  mixin: ActivityStateMixinState;
}

export class AddChatActivity extends React.Component<AddChatActivityProps, AddChatActivityState> {
  constructor(props: AddChatActivityProps) {
    super(props);

    this.activityStateMixin = new ActivityStateMixin(
      (state) =>
        this.setState((_prevState: AddChatActivityState) => ({
          mixin: state,
        })),
      this.props.appState
    );

    this.state = {
      mixin: this.activityStateMixin.initialState(),
    };
  }

  private activityStateMixin: ActivityStateMixin;

  componentWillUnmount() {
    this.activityStateMixin.componentWillUnmount();
  }

  render() {
    return (
      <ScreenSkeleton
        title={translate(STRINGS.CHOOSE_WHO_TO_CONTACT)}
        titleBarStyle={ScreenSkeleton.TitleBarStyle.PRIMARY}
        onBackClick={this.props.onBackClick}
      >
        {isLoading(this.props.appState.appAgenciesState) ? null : (
          <AgenciesListActivity
            agencies={this.props.appState.appAgenciesState.agencies}
            onClickChatWithAgencyMember={this.props.onAddChat}
            onClickChatWithMedflytAgency={this.props.onAddChatMedflytAgency}
            onClickCancelAgency={(agencyId) =>
              cancelAgencyRequest(agencyId, this.props.api, this.props.appState)
            } // TODO
          />
        )}
      </ScreenSkeleton>
    );
  }
}
